import {CompetitionRouteMetaDataModel} from "./competition-route.meta-data.model";
import {BaseRouteConfig} from "../../../core/components/router/models/base-route-config";
import {ROUTE_NAMES} from "../../../core/consts";
import {ReactLazyPreload} from "../../../core/components/router/react-lazy-preload";
import {CompetitionMatchModel} from "./competition.match-model";

export class CompetitionRouteConfig extends BaseRouteConfig {
  static injectables = [];

  constructor(props) {
    super(props);

    this.name = ROUTE_NAMES.competition;
    this.path = `/:sportName/league/:key`;
    this.component = ReactLazyPreload(() => import("../components/competition-container" /* webpackChunkName: "competition-container" */ ));
    this.metadataType = CompetitionRouteMetaDataModel;
    this.matchType = CompetitionMatchModel;
  }
}
